import { BLOG_URL } from '@source/constants/config';

const ANNOUNCEMENT_CONTENT = {
  my: {
    href: 'https://carro.co/my/blog/mytukar-renames-carro',
    mainText: 'shared.temporaryBanner.my.mainText',
    subText: 'shared.temporaryBanner.my.subText',
    isShowTemporaryBanner: true,
  },
  hk: {
    href: `${BLOG_URL.hk}/beyond-cars-更名為-carro`,
    mainText: 'shared.temporaryBanner.hk.mainText',
    subText: 'shared.temporaryBanner.hk.subText',
    isShowTemporaryBanner: true,
  },
};

export default ANNOUNCEMENT_CONTENT;
